module.exports = __webpack_public_path__ + "static/back8-e7e33d5f49f6ce51b63dd4e226aa993f.png";